import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { createSelector, Store } from '@ngrx/store';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { UserPageMergeConflictDialogActions } from './user-page-merge-conflict-dialog.actions';
import { userPageMergeConflictDialogFeature } from './user-page-merge-conflict-dialog.feature';

@Component({
    selector: 'app-user-page-merge-conflict-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        FreyaCommonModule,
        SharedModule,
    ],
    templateUrl: './user-page-merge-conflict-dialog.component.html',
    styleUrls: ['./user-page-merge-conflict-dialog.component.scss'],
})
export class UserPageMergeConflictDialogComponent {

    viewModel$ = this.store.select(createSelector({
        visible: userPageMergeConflictDialogFeature.selectVisible,
        company: userPageMergeConflictDialogFeature.selectCompany,
        billingAddress: userPageMergeConflictDialogFeature.selectBillingAddress,
        selectedCompany: userPageMergeConflictDialogFeature.selectSelectedCompany,
        selectedBillingAddress: userPageMergeConflictDialogFeature.selectSelectedBillingAddress,
        hasConflicts: createSelector(
          userPageMergeConflictDialogFeature.selectCompany,
          userPageMergeConflictDialogFeature.selectBillingAddress,
          (company, billingAddress) => Boolean(company || billingAddress),
        ),
    }));

    actions = UserPageMergeConflictDialogActions;

    constructor(public store: Store) {}
}
